module.exports = __webpack_public_path__ + "assets/img/21.efe75c4e.png";